// комопнент для показа анимированых иконок в Списке Дел

// комопнент для показа анимированых иконок в Списке Дел

'use client';

import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

export default function WeatherIcon({ icon }: { icon: string }) {
  // ИСПРАВЛЕНО: Заменили any на unknown, так как мы не знаем (и не должны знать) структуру Lottie-файла
  const [animationData, setAnimationData] = useState<unknown>(null);

  useEffect(() => {
    async function loadAnimation() {
      try {
        // так как у тебя все иконки в /public/animations/
        const data = await fetch(icon).then((res) => res.json());
        setAnimationData(data);
      } catch (err) {
        console.error('Ошибка загрузки анимации:', err);
      }
    }
    if (icon) loadAnimation();
  }, [icon]);

  if (!animationData) return null;

  return <Lottie animationData={animationData} loop autoplay className="w-6 h-6" />;
}